export default __webpack_public_path__ + "static/media/cakephp.79d2e9c5.svg";